import React, { useMemo } from 'react';
import { useLanguage } from '~/Hooks';
import { FilterCheckboxList } from '~/Components/Filter';
import { useSelectedMap } from '~/Hooks/useFilter/useSelectedMap';
import { FilterType } from '~/Hooks/useFilter';
import { useProviderFilters } from '~/Hooks/useFilter/useProviderFilters';
import { useRequestCategoryList } from '~/requests/eventService';
import { useSportCatgeroy } from '~/Helpers/SportCategory';

export interface IUseEventCategoriesGroupFilterProps {
  filterType: FilterType;
  initialFilter?: string[];
}

export const useEventSportsCategoriesGroupFilter = ({
  filterType,
  initialFilter = [],
}: IUseEventCategoriesGroupFilterProps) => {
  const { appliedFilters } = useProviderFilters({ filterType });
  const { categoryTypes: initialState = initialFilter } = appliedFilters;
  const { getCategory } = useSportCatgeroy();
  const { t } = useLanguage();
  const { data: categoryList } = useRequestCategoryList();
  const list = useMemo(
    () =>
      categoryList?.map((category) => ({
        id: category.id.toString(),
        label: getCategory(category.id),
      })) || [],
    [t, categoryList],
  );
  const {
    selectItem,
    onClearMap,
    onApplyMap,
    selectedMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  } = useSelectedMap({ initialState });

  return {
    name: 'categories',
    title: t('event.sportCategory'),
    elements: <FilterCheckboxList list={list} selectItem={selectItem} selectedMap={selectedMap} />,
    onClearMap,
    onApplyMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  };
};
